import { useMemo } from 'react';
import { getDragIndicatorsInChart } from '~/modules/resourcing/common/hooks/useResourceAllocationDragIndicators';
import { mapIsoStringtoUtcObject } from '~/modules/common/dates/convert';
import { useMeContext } from '~/modules/me';
import { PERIOD_SCALE_ENUM } from '~/modules/resourcing/common/enums';
import { ResourceAllocationStatus } from '~/types';

export const useSetResourceAllocationRepeatButton = ({
  chartDisplayDateRange,
  resourceAllocation,
  isEditEnabled,
  project,
  scale
}) => {
  const {
    featureFlags: { isPsaRmpTaskAllocation1Enabled }
  } = useMeContext();

  const { endDragIndicator } = useMemo(
    () =>
      getDragIndicatorsInChart({
        chartDisplayDateRange,
        resourceAllocation
      }),
    [chartDisplayDateRange, resourceAllocation]
  );

  const showSetResourceAllocationButton =
    isPsaRmpTaskAllocation1Enabled &&
    isEditEnabled &&
    endDragIndicator &&
    resourceAllocation?.allocationStatus === ResourceAllocationStatus.Committed;

  const { defaultStartDate, defaultEndDate } = useMemo(() => {
    const startDate = mapIsoStringtoUtcObject(resourceAllocation.endDate).plus({
      days: 1
    });

    const endDateScale =
      scale === PERIOD_SCALE_ENUM.DAYS ? PERIOD_SCALE_ENUM.WEEKS : scale;
    const projEndDate = project?.endDate
      ? mapIsoStringtoUtcObject(project.endDate)
      : null;

    const endDate =
      projEndDate && startDate < projEndDate
        ? projEndDate
        : startDate.plus({ [endDateScale]: 1 }).minus({ days: 1 });

    return { defaultStartDate: startDate, defaultEndDate: endDate };
  }, [resourceAllocation?.endDate, project?.endDate, scale]);

  return { showSetResourceAllocationButton, defaultStartDate, defaultEndDate };
};
